import request from '@/utils/request'

/**
 * 查询管理员会员用户
 * @param {Object} params 查询参数
 * @returns {Promise} 返回Promise对象
 */
export function queryAdminVipUser(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopVipUser.queryAdminVipUser',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}